import React, {
	Component,
	PropTypes
} from 'react';
import {
	Link
} from "react-router";
var ReactBsTable = require('react-bootstrap-table');
var BootstrapTable = ReactBsTable.BootstrapTable;
var TableHeaderColumn = ReactBsTable.TableHeaderColumn;
import {ellaUrl} from '../../../path.config'
export default class SubsystemsyncIndex extends Component {
	constructor(props) {
		super(props);
		this.handle = this.handle.bind(this);
		this.delList = this.delList;
		this.delClick = this.delClick;
		this.search = this.search.bind(this);
		this.onPageChange = this.onPageChange.bind(this);
		this.state = {
			list: [],
			size: 10,
			current: 1,
			total: 0,
			delRow: {id:"",name:""},
			url:ellaUrl
		};
	}
	componentDidMount() {
		this.onPageChange(this.state.current,this.state.size);
	}
	handle(cell, row) {
		return (<div>
			<Link  to = {"/ella/user/subsystemsync/subsystemsyncEdit/"+row.id} className="btn btn-xs btn-info">
		                编辑
		            </Link>&nbsp;&nbsp;
			<a className="btn btn-xs btn-danger" data-target="#tipModal" data-toggle="modal" onClick={this.delList.bind(this,row.id,row.roleName)}>删除</a>&nbsp;&nbsp;
			<Link className="btn btn-warning btn-sm" to={"/ella/user/subsystemsync/subsystemsyncDetail/"+row.id} >详情</Link>
		</div>);

	};
	delList(id, name) {
		var delRow = {
            id:id,
            name:name,
        };
        this.setState({
            delRow:delRow
        });
	};
	onPageChange(page, sizePerPage, e) {
		const name = $.trim($("#name").val());
        const url = this.state.url + "/subsystemsync/searchList";
        const json = {
            page:this.state.current,
            pageSize:this.state.size,
			search:name,
        };
        $.ajax({
            type: "POST",
            url: url,
            data: JSON.stringify(json),
            contentType: "application/json;charset=UTF-8",
            success: function(data) {
                if(data.data !=null){
                    this.setState({
                        current:json.page,
                        pageSize:json.pageSize,
                        list : data.data.page.records,
                        total : data.data.page.total
                    })
                }
            }.bind(this),
            error: function(data) {
                console.log("Get Area info error");
            }.bind(this),
        });
	}
	search() {
		this.onPageChange(this.state.current,this.state.size);
	}

	delClick(id){
        var self = this;
        $.ajax({
            type: "GET",
            url: this.state.url+"/subsystemsync/doDelete/"+id,
            success: function(data) {
                if (data.code == 8001) {
                    $("#success_msg").text(data.msg);
                    $("#success_tip").removeClass("hidden");
                    setTimeout(function() {
                        $("#success_tip").addClass("hidden");
                        var json = {
                            page:1,
                            pageSize:self.state.pageSize,
                        };
                        self.getRoleList(json);
                    }, 2000);
                } else {
                    $("#error_msg").text(data.msg);
                    $("#error_tip").removeClass("hidden");
                    setTimeout(function() {
                        $("#error_tip").addClass("hidden");
                    }, 2000);
                }
            }.bind(this),
            error: function(data) {
                console.log("del error");
            }.bind(this),
        });
    }

	render() {
		const options = {
            noDataText:"没找到数据",
            page: this.state.current, //当前页
            sizePerPageList: [10, 15, 20],
            sizePerPager: this.state.pageSize,
            pageStartIndex: 1,
            paginationSize: 5,
            firstPage: '首页',
            lastPage: '尾页',
            onPageChange: this.onPageChange,
        }
		return (
			<div >
				<section className="content-header " >
			               	 <h1> 子系统信息管理 <small>子系统信息列表</small> </h1>
			            </section>
			             <section className="content" >
		             		<div className="box box-primary color-palette-box">
		                 			 <div className="box-header with-border">
		                   				 <i className="fa fa-list"></i>
		                    				<h3 className="box-title">子系统信息列表</h3>
		                    				<div style={{marginRight:"10px",float:"right"}}>
						                      <Link  to = "/ella/user/subsystemsync/subsystemsyncAdd" className="btn btn-success btn-md"  >
						                        	<i className="fa fa-plus-circle"></i> 添加
						                      </Link>
						            </div>
		                  			</div>
		                  			<div className="box-body">
		                       				<div id={"error_tip"} className="hidden alert-tip">
		                        					<div className="alert alert-danger">
		                          					<strong>Whoops!</strong>
		                            					<button type="button" className="close" data-dismiss='alert'>×</button>
		                            					<span id={"error_msg"}>&nbsp;提交失败.</span>
		                        					</div>
		                      				</div> 
						             <div id={"success_tip"} className="hidden alert-tip">
						                          <div className="alert alert-success">
						                          	<button type="button" className="close" data-dismiss='alert'>×</button>
						                            	<strong>Success.</strong><span id={"success_msg"}>提交成功</span>
						                        </div>
						             </div>
		                       				<div className="col-xs-12" style={{paddingLeft:"0px"}}>
		                        				<label  className="pull-left control-label" style={{paddingTop:"5px"}}>搜索条件</label>
			                        			<div className="col-xs-2" style={{marginBottom:"15px"}}>
				                       				 <input type="text" className="form-control" placeholder="子系统名称、访问路径" id="name"/>
				                    			</div>
				                    			
				                     			<div  className=" col-xs-2" >
				                     				<a  className="btn btn-info btn-md" onClick={this.search}>
				                        					<i className="fa fa-plus-circle"></i> 查询
				                      				</a>
				                    			</div>
			                    			</div>
			                    			<div >
				                        			<BootstrapTable data = {this.state.list}  remote={true} fetchInfo={{ dataTotalSize: this.state.total }} striped hover pagination={true} options={options} ref='table' >
				                        				<TableHeaderColumn isKey dataField='id' hidden={true}> id</TableHeaderColumn>
				                        				<TableHeaderColumn dataField='name'> 子系统名称 </TableHeaderColumn>
				                        				<TableHeaderColumn  dataField='remark'>访问路径</TableHeaderColumn>
				                        				<TableHeaderColumn  dataFormat={this.handle}  columnClassName="td-mid">操作</TableHeaderColumn>
				                        			</BootstrapTable>
		                  				</div>
		                  			</div>
		                		</div>
		             	</section>
		             	<div className="modal fade" id="tipModal" tabIndex="-1" role="dialog"
                     		aria-labelledby="myModalLabel" aria-hidden="true" style={{marginTop:"15%"}}>
	                    	<div className="modal-dialog">
	                        <div className="modal-content">
	                            <div className="modal-header">
	                                <button type="button" className="close"
	                                        data-dismiss="modal" aria-hidden="true">
	                                    &times;
	                                </button>
	                                <h4 className="modal-title" id="myModalLabel">
	                                    <strong>系统确认</strong>
	                                </h4>
	                            </div>
	                            <div className="modal-body">
	                                确定删除&nbsp;&nbsp;&nbsp;<kbd className={this.state.delRow.name?"kbd-set":"hidden"}>{this.state.delRow.name}</kbd>&nbsp;&nbsp;?
	                            </div>
	                            <div className="modal-footer">
	                                <button type="button" className="btn btn-default"
	                                        data-dismiss="modal">关闭
	                                </button>
	                                <button type="button" className="btn btn-primary" data-dismiss="modal"
	                                        onClick={this.delClick.bind(this,this.state.delRow.id)}>确认
	                                </button>
	                            </div>
	                        </div>
	                    	</div>
                		</div>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./modules/ella/user/subsystemsync/subsystemsyncIndex.js